import { modalsSelectorFactory } from 'app/store/modal/selectors';
import React, { FC } from 'react';
import { Dialog } from 'shared/components/Dialog';
import { DialogName } from 'app/enums';
import { Box, Button, Typography } from '@mui/material';
import { useStyles } from './ConfirmationDialog.styles';
import { modalsReducers } from 'app/store/modal/slice';
import { useDispatch, useSelector } from 'react-redux';

interface ConfirmationDialogProps {
  title: string;
  description: string;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  onAccept: (payload?: any) => void;
}

export const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
  title,
  description,
  onAccept,
}) => {
  const dispatch = useDispatch();
  const { classes } = useStyles();
  const payload = useSelector(modalsSelectorFactory.useModalPayload(DialogName.Confirmation));

  const onCloseHandler = (): void => {
    dispatch(modalsReducers.closeModal(DialogName.Confirmation));
  };

  const acceptHandler = (): void => {
    dispatch(modalsReducers.closeModal(DialogName.Confirmation));
    if (payload) {
      onAccept?.(payload);
    } else {
      onAccept?.();
    }
  };

  return (
    <Dialog
      maxWidth="sm"
      contentHeight={150}
      name={DialogName.Confirmation}
      actions={
        <>
          <Button
            fullWidth
            size="medium"
            color="error"
            variant="outlined"
            className={classes.cancelButton}
            onClick={onCloseHandler}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            size="medium"
            color="primary"
            variant="contained"
            onClick={acceptHandler}
          >
            Confirm
          </Button>
        </>
      }
    >
      <Box className={classes.root}>
        <Typography className={classes.title}>{title}</Typography>
        <Typography>{description}</Typography>
      </Box>
    </Dialog>
  );
};
